import { gql } from '@apollo/client';

export const FILTER_BRANCHES = gql`
  query filterBranches($searchFilter: SearchFilter!) {
    filterBranches(searchFilter: $searchFilter) {
      id
      code
      name
    }
  }
`;

export const FIND_ONE_USER = gql`
  query findUser($userId: Int!) {
    findUser(userId: $userId) {
      id
      name
      username
      password
      document
      email
      roles {
        description
        name
        rules {
          id
          action
          subject
          fields
          condition
          inverted
          reason
        }
      }
      clients {
        id
        name
        username
        password
        client_id
        client_secret
        host
        createdAt
        updatedAt
        banner {
          id
          layouts {
            id
            name
            campaign
            orientation
            filename
            hasForehead
            colors
            sizes {
              name
              width
              height
            }
            dynamics {
              name
              description
            }
          }
          configs {
            id
            name
            description
            content
          }
        }
      }
      filials {
        id
        fantasyName
        code
        qrcode
        clientId
        addressId
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const RECOVER_PASSWORD = gql`
  mutation RecoverPassword($recoverPasswordInput: RecoverPasswordInput!) {
    RecoverPassword(recoverPasswordInput: $recoverPasswordInput)
  }
`;

export const UPDATE_USER_PASSWORD = gql`
  mutation UpdateUserPassword(
    $updateUserPasswordInput: UpdateUserPasswordInput!
  ) {
    UpdateUserPassword(updateUserPasswordInput: $updateUserPasswordInput)
  }
`;
